import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";

import global_mixin from "@/mixins/global-mixin.js";
Vue.mixin(global_mixin);

import AsCampoValor from '@/components/AS/AsCampoValor.vue';
Vue.component('AsCampoValor', AsCampoValor);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
